import { useQuery } from "@tanstack/react-query";
import { aboutRepo } from "@/lib/repositories";

export function useFetchAbout(id?: string) {
  const query = useQuery({
    queryKey: ["abouts", id],
    queryFn: () => aboutRepo.fetchOne(id!),
    enabled: !!id,
  });
  return { about: query.data, isLoading: query.isLoading };
}
